import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage } from '../../../Redux/Slices/generalSlice';


/* Screens Import */
import LanguageSelect from '../../CommonScreens/LanguageSelect/LanguageSelect';
import NameAndEmail from '../../CommonScreens/NameAndEmail/NameAndEmail';
import WelcomeScreen from '../../CommonScreens/WelcomeScreen/WelcomeScree';
import EpisodeSelector from '../EpisodeSelector/EpisodeSelector';

import Episode1_MainPage from '../../Episode1/Episode1_MainPage/Episode1_MainPage';
import Episode2_MainPage from '../../Episode2/Episode2_MainPage/Episode2_MainPage';
import Episode3_MainPage from '../../Episode3/Episode3_MainPage/Episode3_MainPage';


function CommonPages() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);


    if (pageNo === 0) {
        return (
            <div>
                <LanguageSelect />
            </div>
        )
    } else if (pageNo === 1) {
        return (
            <div>
                <NameAndEmail />
            </div>
        )
    } else if (pageNo === 2) {
        return (
            <div>
                <EpisodeSelector />
            </div>
        )
    } else if (pageNo >= 3 && pageNo <= 26){
        return(
            <Episode1_MainPage />
        )
    } else if (pageNo >= 27 && pageNo <= 54){
        return(
            <Episode2_MainPage />
        )
    } else if (pageNo >= 55 && pageNo <= 74){
        return(
            <Episode3_MainPage />
        )
    }
}

export default CommonPages;